import React from 'react';

const Citation1 = () => {
    return (
        <div style={{ background: '#fff'}}>
            <div style={{ textAlign: 'center', fontFamily: 'Lato, sans-serif', padding: '0 5px', boxSizing: 'border-box', backgroundColor: 'rgb(255, 255, 255)' }}>
                <h3 style={{ color: 'rgb(26, 26, 26)', lineHeight: 1.3, fontSize: '24px', maxWidth: '800px', margin: '0 auto' }}>
                    <span style={{ color: 'rgb(0, 0, 0)', textTransform: 'none', letterSpacing: 'normal', fontWeight: 400 }}>
                        L'imam Ibn 'Abdel Bar (mort en 463 du calendrier hégirien) a dit : 
                        « Les gens de science disent qu'il est recommandé à celui qui en a la capacité de s'embellir en portant de beaux vêtements dans sa prière, en se parfumant et en utilisant le siwak ».
                    </span>
                    <br />
                    <strong>(Al Tamhid vol 6 p 369)</strong>
                </h3>
            </div>
        </div>
    );
};

export default Citation1;